import { render, staticRenderFns } from "./AccountArticles.vue?vue&type=template&id=ca10b90c&"
import script from "./AccountArticles.vue?vue&type=script&lang=ts&"
export * from "./AccountArticles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports